import { render, staticRenderFns } from "./ComboBoxWrapper.vue?vue&type=template&id=25bd0ab4&v-if=options"
import script from "./ComboBoxWrapper.vue?vue&type=script&lang=js"
export * from "./ComboBoxWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports